<template>
  <CouponVipPopupCustomer
    v-if="useCustomer"
    :couponList="couponList"
    @closeCouponPopup="closeCouponPopup"
  ></CouponVipPopupCustomer>
  <CouponVipPopupCommon
    v-else
    :couponList="couponList"
    @closeCouponPopup="closeCouponPopup"
  ></CouponVipPopupCommon>
</template>

<script>
import { mapState } from 'vuex';
import CouponVipPopupCommon from './CouponVipPopupCommon.vue';
import CouponVipPopupCustomer from './CouponVipPopupCustomer.vue';

export default {
  name: 'CouponVipPopup',
  props: {
    couponList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapState({
      couponPopupPicList: state => state.page.couponPopupPicList,
      colorConfig: state => state.page.colorConfig
    }),
    useCustomer() {
      return this.couponPopupPicList.sendCouponBg;
    }
  },
  methods: {
    closeCouponPopup() {
      this.$emit('closeCouponPopup');
    }
  },
  components: {
    CouponVipPopupCommon,
    CouponVipPopupCustomer
  }
};
</script>
